var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t(`Connectors.Monitoring.dialogs.${_vm.dialogKey}.title`),
      "open": _vm.open,
      "color": _vm.isDelete ? 'danger' : _vm.color,
      "buttons": [{
        text: _vm.$i18n_t('Connectors.Monitoring.dialogs.disable.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Connectors.Monitoring.dialogs.disable.confirm'),
        color: _vm.isDelete ? 'danger' : _vm.color,
        emit: 'proceed'
      }]
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      },
      "cancel": function ($event) {
        return _vm.$emit('close');
      },
      "proceed": function ($event) {
        return _vm.$emit('confirm', _vm.isDelete);
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t(`Connectors.Monitoring.dialogs.${_vm.dialogKey}.message`)))])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };